import React, { useState,useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import './style.css'
import Navbar from '../../components/navbar'
import Banner1 from './banner/banner1'
import Banner2 from './banner/banner2'
import {Button,Tab,Tabs,CircularProgress,
    RadioGroup,FormControlLabel,Radio,TextField } from '@material-ui/core'
import { MuiThemeProvider, createMuiTheme,withStyles, } from '@material-ui/core/styles'
import Information from './information'
import Agenda from './agenda'
import Registration from './registration'
import Documentation from './documentation'
import DownloadBlue from '../../assets/image/Download-blue.svg'
import {groupBy} from 'lodash'
import NumberFormat from 'react-number-format';
import {getEventDetail,getImageEventList} from '../../redux/action/event'
import {withRouter} from 'react-router-dom';
import Skeleton from 'react-loading-skeleton'
import moment from 'moment'
import Loader from '../../components/skeleton/loader_detail_event'
import Footer from '../../components/footer'
import Modal from '../../components/modal'

import axios from 'axios'
import {URL,USER,PASS} from '../../service/base_url'
import {get} from 'lodash'
const themeButton = createMuiTheme({ 
    palette: { 
        primary: {
            main:'#00a1ed',
            contrastText: '#FFFFFF',
        },
    } 
})
const renderIvestment=(data)=>{
    
    let group=groupBy(data,(data)=>{
        return data.title
    })
    let investment=Object.entries(group)
    let cekdiskon=[]
    let a=investment.map((data,i)=>{
        let havediscount=false
        let cek=data[1].filter(data=>{
            return data.type==='Discount Price'
        })
        
        if(cek.length>0){
            havediscount=true
        }
        cekdiskon.push({...data,havediscount})
    })
    let map=cekdiskon.map((data,i)=>(
        <div key={i}>
            <div className={`investment-title${data[0]==='Free'?'-free':''}`}>
            <p>{data[0]}</p>
            </div>
            <div className='sub-investment'>
                {data.havediscount?
                    <>
                    {data[1].map((subdata,i)=>(
                        <div style={{marginBottom:10}}>
                            {subdata.type==='Normal Price'&&
                            <p  style={{color:'#cccccc'}}>Normal Prices :<strike style={{color:'red'}}><span style={{color:'#cccccc'}}><NumberFormat prefix={'Rp'} value={subdata.nominal} displayType={'text'} thousandSeparator={true}  /> {subdata.ppn&&`+ PPn ${subdata.ppnpercent}%`}</span></strike> </p>
                            }
                        </div>
                    ))}
                    {data[1].map((subdata,i)=>(
                        <div style={{marginBottom:10}}>
                            {subdata.type==='Discount Price'&&
                            <p>Now only : <NumberFormat value={subdata.nominal} displayType={'text'} thousandSeparator={true}  prefix={'Rp'}/> {subdata.ppn&&`+ PPn ${subdata.ppnpercent}%`}</p>
                            }
                        </div>
                    ))}
                    </>
                :
                    data[1].map((subdata,i)=>(
                        <div style={{marginBottom:10}}>
                            
                            {subdata.type!=='Free'&&<p>{subdata.type} : <NumberFormat value={subdata.nominal} displayType={'text'} thousandSeparator={true}  prefix={'Rp'}/> {subdata.ppn&&`+ PPn ${subdata.ppnpercent}%`}</p>}
                            
                        </div>
                    ))
                }
                
                
            </div>
        </div>
    ))
    return map
}
const  Detail=(props)=> {
    const [tabs_active,tabsToggle]=useState('information')
    const [is_open,toggleOpen]=useState(true)
    const [tabs_mobile_active,tabsMobileToggle]=useState(0)
    const [state,setState]=useState({
        isOpen: false,
        title:'',
        name:'',
        phoneNumber:'',
        email:'',
        companyName:'',
        loading:false,
        open:false
    })
    const [menu,setMenu]=useState([
        {id:0,title:'Information',open:true},
        {id:1,title:'Agenda',open:true},
        {id:2,title:'Registration',open:true},
        {id:3,title:'Documentation',open:true},
    ])
    const dispatch=useDispatch()
    const event=useSelector(state=>state.event)
    const general=useSelector(state=>state.general)
    useEffect(async()=>{
        dispatch(getEventDetail(props.match.params.slug))
        dispatch(getImageEventList(props.match.params.slug))
       
    },[])
    const handleOpen=()=>{
        let date=moment(event.detail_event.event.fromDate).subtract(1, 'days').format('YYYY-MM-DD')
        let now=moment().format('YYYY-MM-DD')
        let is_open=moment(date).isSameOrAfter(now)
        return is_open
    }
    const menuToggle=()=>{
       
    }
    const  a11yProps=(index)=> {
        return {
          id: `scrollable-auto-tab-${index}`,
          'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
      }
    const submit=(e)=>{
        e.preventDefault()
        setState({...state,loading:true})
        let {name,phoneNumber,email,companyName,title}=state
        axios.post(`${URL}`,{
            name,phoneNumber,email,companyName,action:`eventbrochure-${title}`
        },{
            auth: {
                username: USER,
                password: PASS
                }
        }).then((res)=>{
            if(get(res,'status')==200){
                setState({...state,loading:false})

                setState({...state,success_form:!state.success_form,request_form:!state.request_form})
            }else{
                setState({...state,loading:false})
                alert('Ops something error')
            }
        })
    }
    const onChange=(e)=>{
        const {value,name}=e.target
        setState({...state,[name]:value})
    }
    const toggleRequest=(title)=>{
        setState({...state,request_form:!state.request_form,title})
    }
    const toggleSucces=()=>{
        setState({...state,success_form:!state.success_form})
    }
    const children=()=>{
        let {loading}=state
        return(
            <div>
                <p>Please fill out the form below to request a copy of brochure</p>
                <br/>
                <form onSubmit={submit}>
                <TextField
                    label="Name"
                    // label={<p>Name<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='name'
                    onChange={onChange}
                    required
                />
                <br/><br/>
                <TextField
                    label='Email'
                    // label={<p>Email<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='email'
                    onChange={onChange}
                    required
                    type="email"
                />
                <br/><br/>
                <TextField
                    label="Phone No."
                    // label={<p>Phone No.<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='phoneNumber'
                    onChange={onChange}
                    required

                />
                <br/><br/>
                <TextField
                    label="Company name"
                    // label={<p>Company name<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='companyName'
                    onChange={onChange}
                    required
                />
                <br/><br/>
                <Button type='submit' style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">
                    {loading? <CircularProgress size={20} style={{color:'white'}}/>:'Send'}
                </Button>
                </form>
            </div>
        )
    }
    const children2=()=>{
        return(
            <div>
                <p>Thank you for your interest in One GML. we will contact you as soon as possible</p>
                <br/>
                <Button onClick={toggleSucces} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Ok</Button>
            </div>
        )
    }
    // console.log('event', event.detail_event)
    
    // console.log('index', tabs_mobile_active)
    const toRegis=()=>{
        if(event.detail_event.event.registrationURL!==""){
            window.open(event.detail_event.event.registrationURL,'_blank')
        }else{
            tabsToggle('registration')
        }
        // console.log('event.detail_event', event.detail_event)
        
    }

    return (
        <div>
            <Navbar/>
            <Modal title="Download brochure" isOpen={state.request_form} children={children()} modalToggle={toggleRequest}/>
            <Modal title="Request brochure recorded" isOpen={state.success_form} children={children2()} modalToggle={toggleSucces}/>
            <br/><br/><br/><br/>
            {event.detail_event!==null?
            <>
            {event.detail_event.category.id===1||event.detail_event.category.id===2?
            <Banner1 loading={general.isLoading} event={event.detail_event} toggleRequest={toggleRequest}/>
            :
            <Banner2 loading={general.isLoading} event={event.detail_event}/>
            } 
            <div className={`detail-content ${event.detail_event.category.id===1||event.detail_event.category.id===2?'margin-top-event':'margin-top-webinar'}`}>
                <div className='detail-content-description'>
                    <MuiThemeProvider theme={themeButton}>
                        <div className='tab'>
                            <Button onClick={()=>tabsToggle('information')} color='primary' className='btn-remove-capital btn-tab' size='small' variant={tabs_active==='information'?'outlined':''}>Information</Button>
                            {event.detail_event.agenda.length>0&&<Button onClick={()=>tabsToggle('agenda')} color='primary' className='btn-remove-capital btn-tab' size='small' variant={tabs_active==='agenda'?'outlined':''}>Agenda</Button>}
                            {handleOpen()&&<Button onClick={()=>toRegis()} color='primary' className='btn-remove-capital btn-tab' size='small' variant={tabs_active==='registration'?'outlined':''}>Registration</Button>}
                            {event.image_event.length>0&&<Button onClick={()=>tabsToggle('documentation')} color='primary' className='btn-remove-capital btn-tab' size='small' variant={tabs_active==='documentation'?'outlined':''}>Documentation</Button>}
                        </div>
                    </MuiThemeProvider>
                    <br/>
                    {tabs_active==='information'&&<Information event={event.detail_event}/>}
                    {tabs_active==='agenda'&&<Agenda event={event.detail_event}/>}
                    {tabs_active==='registration'&&<Registration event={event.detail_event}/>}
                    {tabs_active==='documentation'&&<Documentation image={event.image_event}  />}
                </div>
                {/* {event.category.toString()==='1'||event.category.toString()==='3'||event.category.toString()==='4'? */}
                <div>
                { event.detail_event.category.id!==2&&
                <div className='detail-content-investment'>
                    {general.isLoading?
                    <Skeleton height={100}/>
                    :
                   
                    <>
                    <div className='investment-head'>
                        <h3>Investment</h3>
                    </div>
                    <div className='investment-body'>
                        {renderIvestment(event.detail_event.investments)}
                        
                        <br/>
                        
                        <MuiThemeProvider theme={themeButton}>
                        {event.detail_event.category.id!==3&&event.detail_event.category.id!==4?
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                                <Button style={{textTransform:'none'}} startIcon={<img src={DownloadBlue} style={{width:15}}/>} size="small" color="primary" onClick={()=>toggleRequest(event.detail_event.event.title)}>Download brochure</Button>
                                {handleOpen()&&<Button style={{textTransform:'none'}} variant='contained' size="small" color="primary" onClick={()=>toRegis()}>Registration</Button>}
                            </div>
                        :
                        <div style={{display:'flex',justifyContent:'flex-end'}}>
                            {handleOpen()&&<Button style={{textTransform:'none'}} variant='contained' size="small" color="primary" onClick={()=>toRegis()}>Registration</Button>}
                        </div>
                        }
                        </MuiThemeProvider>
                       
                    </div>
                    </>}
                </div>
                }
                </div>
                {/* :null} */}
            </div>
            {general.isLoading!==true&&
            <>
            <MuiThemeProvider theme={themeButton}>
                <div className='tab-mobile'>
                    {/* <Tabs
                        value={tabs_mobile_active}
                        onChange={(tabs,key)=>console.log('tabs',tabs,key)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        {menu.map((data,i)=>(
                            <Tab label={data.title} {...a11yProps(data.id)} />
                        ))}
                        <Tab label="Information" {...a11yProps(0)} />
                        {event.detail_event.category.id!==3&&event.detail_event.category.id!==4&&<Tab label="Agenda" {...a11yProps(1)} />}
                        {handleOpen()&&<Tab label="Registration" {...a11yProps(2)} />}
                        {event.image_event.length>0&&<Tab label="Documentation" {...a11yProps(3)} />}
                    </Tabs> */}
                    <li onClick={()=>tabsToggle('information')} className={`tab-mobile-list ${tabs_active==='information'&&'tab-mobile-list_active'}`}>INFORMATION</li>
                    {event.detail_event.agenda.length>0&&<li onClick={()=>tabsToggle('agenda')} className={`tab-mobile-list ${tabs_active==='agenda'&&'tab-mobile-list_active'}`}>AGENDA</li>}
                    {handleOpen()&&<li onClick={()=>toRegis()} className={`tab-mobile-list ${tabs_active==='registration'&&'tab-mobile-list_active'}`}>REGISTRATION</li>}
                    {event.image_event.length>0&&<li onClick={()=>tabsToggle('documentation')} className={`tab-mobile-list ${tabs_active==='documentation'&&'tab-mobile-list_active'}`}>DOCUMENTATION</li>}
                </div>  
            </MuiThemeProvider>
            <br/>
            <div className='detail-content-mobile'>
                {/* {menu.map((data,i)=>{
                    if(tabs_mobile_active===data.id){
                        return(
                            
                        )
                    }
                })} */}
                {tabs_active==='information'&&<Information event={event.detail_event}/>}
                {tabs_active==='agenda'&&<Agenda event={event.detail_event}/>}
                {tabs_active==='registration'&&<Registration event={event.detail_event}/>}
                {tabs_active==='documentation'&&<Documentation  image={event.image_event}/>}
                {/* {event.detail_event.category.id===1?
                    <>
                    <div style={{display:tabs_mobile_active===1?'':'none'}}>
                        <Agenda event={event.detail_event}/>
                    </div>
                    <div style={{display:tabs_mobile_active===3?'':'none'}}>
                        <Documentation image={event.image_event}/>
                    </div>
                    <div style={{display:tabs_mobile_active===0?'':'none'}}>
                        <Information event={event.detail_event}/>
                    </div>
                    <div style={{display:tabs_mobile_active===2?'':'none'}}>
                        <Registration event={event.detail_event}/>
                    </div>
                    </>
                    :
                    <>
                    <div style={{display:tabs_mobile_active===2?'':'none'}}>
                        <Documentation image={event.image_event}/>
                    </div>
                    <div style={{display:tabs_mobile_active===0?'':'none'}}>
                        <Information event={event.detail_event}/>
                    </div>
                    <div style={{display:tabs_mobile_active===1?'':'none'}}>
                        <Registration event={event.detail_event}/>
                    </div>
                    </>
                } */}
               
                {/* {event.investment.map((data,i)=>(
                    <div key={i}>
                            <div className='investment-title'>
                            <p>{data.title}</p>
                        </div>
                        {data.type!=='Free'&&
                        <div className='investment-body'>
                            {data.type!=='Discount Price'?
                            <p>{data.type} : <NumberFormat value={data.nominal} displayType={'text'} thousandSeparator={true}  /> {data.ppn===1&&`+ ppn ${data.ppnpercent}%`}</p>
                            :
                            <p  style={{color:'#cccccc'}}>Normal Prices :<strike style={{color:'red'}}><span style={{color:'#cccccc'}}><NumberFormat value={data.nominal} displayType={'text'} thousandSeparator={true}  /> {data.ppn===1&&`+ ppn ${data.ppnpercent}%`}</span></strike> </p>
                            }
                        </div>
                        }
                    </div>
                ))} */}
            </div>
            <div className='invest-mobile'>
            <div className='investment-head '>
                <h3>Investment</h3>
            </div>
            {event.detail_event.category.id!==2&&renderIvestment(event.detail_event.investments)}
            </div>
            </>}
            </>
            :<Loader/>}
            <br/>
            <Footer/>

        </div>
    )
}

export default withRouter(Detail)
